import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import { Global as EmotionGlobal, css } from '@emotion/react';

import { theme } from '../theme';

const themes = css`
  .tippy-box[data-theme~='light'] {
    font-weight: ${theme.fontWeight.normal};

    .tippy-content {
      padding: ${theme.spacing.md};
    }

    .tippy-close-button {
      position: absolute;
      top: 10px;
      right: 10px;
    }
  }

  .tippy-box[data-theme~='error'] {
    color: white;
    box-shadow: 0 0 20px 4px rgba(154, 161, 177, 0.15), 0 4px 80px -8px rgba(36, 40, 47, 0.25),
      0 4px 4px -2px rgba(91, 94, 105, 0.15);
    background-color: ${theme.colors.danger};
    font-weight: ${theme.fontWeight.black};

    .tippy-content {
      padding: ${theme.spacing.md};
    }

    .tippy-close-button {
      position: absolute;
      top: 8px;
      right: 8px;

      svg {
        color: white;
      }
    }

    .tippy-backdrop {
      background-color: ${theme.colors.danger};
    }

    .tippy-svg-arrow {
      fill: ${theme.colors.danger};
    }
    &[data-placement^='top'] > .tippy-arrow:before {
      border-top-color: ${theme.colors.danger};
    }
    &[data-placement^='bottom'] > .tippy-arrow:before {
      border-bottom-color: ${theme.colors.danger};
    }
    &[data-placement^='left'] > .tippy-arrow:before {
      border-left-color: ${theme.colors.danger};
    }
    &[data-placement^='right'] > .tippy-arrow:before {
      border-right-color: ${theme.colors.danger};
    }
  }
`;

export const TippyThemes = () => <EmotionGlobal styles={themes} />;
